import im from 'immutable';
import Actions from './actions';

const IDENTITY = im.List();

export default (state = IDENTITY, action) => {
  switch (action.type) {
    case Actions.CREATE:
      return state.push(action.state);

    case Actions.UPDATE: {
      const updatedState = action.state;

      return state
        .filter(
          pending => !(pending.entity === updatedState.entity && pending.name === updatedState.name)
        )
        .push(updatedState);
    }

    case Actions.DELETE: {
      const deletedState = state.filter(
        pending => !(pending.entity === action.entity && pending.name === action.name)
      );
      return deletedState;
    }

    default:
      return state;
  }
};
